  // Override Settings
  var bcSfFilterSettings = {
      general: {
          limit: 20,
          /* Optional */
          // loadProductFirst: true,
      }
  };

  // Declare Templates
  var bcSfFilterTemplate = {
      'soldOutClass': 'sold-out',
      'saleClass': 'on-sale',
      'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
      'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
      'vendorHtml': '<div>{{itemVendorLabel}}</div>',

      // Grid Template
      'productGridItemHtml':                   '<div data-id="{{itemId}}" class="collection-content-items">' +
            '<div class="collection-view-item">' +
              '<a class="collection-view-item-link {{anchorClass}}" href="{{itemUrl}}">' +
                '<div class="collection-unique-id">' +
                  '<div class="collection-img">' +
    				'{{itemThumbs}}' +
                  '</div>' +
                '</div>' +
              '</a>' +
              '<div class="collection-information">' +
                '<a class="coll-prod-url" href="{{itemUrl}}">' + 
                  '{{itemTitle}}' +
                '</a>' +
                '<div class="coll-prod-price">' +
                  '<span class="product-price__price">' + '{{itemPrice}}' + '</span>' + 
                '</div>' +
                '<div id="swatch-select-container" class="swatch-select">' +
                	'<span class="swatch-option">{{itemColors}}</span>' +
                '</div>' +
              '</div>' +
    		  '<a href="" class="quick_view">' + '+ Quick View' + '</a>' + 
            '</div>' +
          '</div>' ,

      // Pagination Template
      'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
      'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
      'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
      'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
      'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
      'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
      'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
      'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

      // Sorting Template
      'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
  };

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  BCSfFilter.prototype.buildProductGridItem = function(data, index) {
      /*** Prepare data ***/
     var images = data.images_info;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    
//  	console.log(images)
//     console.log(images[0]['width'])
    
    //     ADD COLOR VARIANT
    var productVariants = data.options_with_values;
    var productLength = productVariants.length;
    var productcolors = '';
    var colorCtr = 0;
//     var varColorthumb = this.optimizeImage(images[0]['src']);
//     var varColorthumb1 = this.optimizeImage(images[1]['src']);
    
    $('#swatch-repo > div').each(function(i,e){
      var $this = $(this);
      if($this.data('name').substring(0,10) == data.title.substring(0,10)){
        if($this.data('name') == data.title){
          productcolors = $(e)[0].outerHTML + productcolors;
        } else {
          productcolors = productcolors + $(e)[0].outerHTML;
        }
      }
    });
    
    /*for (var a = 0; a < productLength; a++){

     $.each(productVariants, function(i,e) {

        if (e.name == "color") {
          var ct = 0;
          $.each(e.values, function(id,el) {
            if(ct == 0){
              colortitle  = el.title
              productcolor = colortitle.toLowerCase().replace(/ /g,'-');

              //productcolors += '<div class="swatch-option image" option-label="'+ colortitle +'"';
              //productcolors += 'option-type="2" data-prodVarId="'+ data.id +'" data-imgScr1="'+varColorthumb+'" data-imgScr2="'+varColorthumb1+'" data-swatch="'+productcolor+'"></div>';
              //colorCtr++;
              //ct++;
            }
          });
        }
      });
    }*/

     
    
      /*** End Prepare data ***/

      // Get Template
      var itemHtml = bcSfFilterTemplate.productGridItemHtml;

      // Add Thumbnail
  //   var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
  //   var itemThumbUrl2 = images.length == 2 ? this.optimizeImage(images[1]['src'] )  : bcSfFilterConfig.general.no_image_url;
  //     itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

//     var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'] )  : bcSfFilterConfig.general.no_image_url;
//     var itemThumbUrl2 = images.length == 2 ? this.optimizeImage(images[1]['src'] )  : bcSfFilterConfig.general.no_image_url;
//     var imageContain = '';
//     var anchorDbl = '';
//     if(images.length == 2){
//       imageContain = '<img class="col-image1" src="'+ itemThumbUrl +'"> <img class="col-image2" src="'+ itemThumbUrl2 +'">';
//       anchorDbl = 'dbl-img-unique';
//     } else if( images.length < 2 ){
//       imageContain = '<img class="col-image1" src="'+ itemThumbUrl +'">';
//       anchorDbl = '';
//     }
//     itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, imageContain)
//     itemHtml = itemHtml.replace(/{{anchorClass}}/g, anchorDbl)
    
      var productItemThumb = '';
      var colorThumbIndex = 0;
      var colorThumbIndex1 = 1;
      var anchorDbl = '';
      for(var clrImg=0; clrImg <= colorCtr; clrImg++){
        if(images.length > colorThumbIndex1){
          var colorThumbURL = this.optimizeImage(images[colorThumbIndex]['src']);
          var colorThumbURL1 = this.optimizeImage(images[colorThumbIndex1]['src']);
          productItemThumb += '<img class="col-image1" src="'+ colorThumbURL +'" data-origSrc="'+ colorThumbURL +'"> <img class="col-image2" src="'+ colorThumbURL1 +'" data-origSrc="'+ colorThumbURL1 +'">';
          anchorDbl = 'dbl-img-unique';
        } else{
          productItemThumb += '<img class="col-image1" src="'+ this.optimizeImage(images[0]['src']) +'" data-origSrc="'+ this.optimizeImage(images[0]['src']) +'">';
          anchorDbl = '';
        
        }
        
        if(data.product_type != 'anybrand'){
          colorThumbIndex ++;
        }

      }
    

      itemHtml = itemHtml.replace(/{{itemThumbs}}/g, productItemThumb);
      itemHtml = itemHtml.replace(/{{anchorClass}}/g, anchorDbl);
    

      // Add Price
//       var itemPriceHtml = '';
//       if (data.title != '')  {


//         itemPriceHtml += '';
//         if (onSale) {
//           if (priceVaries) {
//             itemPriceHtml +=  '<span class="regular-price strike">' + this.formatMoney(data.price_max) + '</span>';
//             itemPriceHtml += '<span class="sale-price">' + (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min)) + '</span>';
//           } else {
//             itemPriceHtml += '<span class="regular-price strike" style="text-decoration: line-through">' + this.formatMoney(data.compare_at_price_min) + '</span> ' + '<span class="sale-price" style="color: red">' + this.formatMoney(data.price_min) + '<span>';
//             //             itemPriceHtml +=  '<span class="regular-price">' + this.formatMoney(data.price_min) + '<span>';
//           }
//         } else {
//           if (priceVaries) {
//             itemPriceHtml += '<span class="regular-price">' + (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min)) + '</span>';
//           } else {
//             itemPriceHtml +=  '<span class="regular-price">' + this.formatMoney(data.price_min) + '</span>';
//           }
//         }
//         itemPriceHtml += '';
//       }
//       itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    
        
//         var itemPriceHtml = '';
//         if (data.title != '')  {
//           itemPriceHtml += '<p class="grid-link__meta">';
//           if (onSale) {
//             itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min) + '</s> ';
//           }
//           if (priceVaries) {
//             if(bcSfFilterConfig.label.from_price != undefined){
//               itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min));
//             }else {
//               itemPriceHtml += this.formatMoney(data.price_min);
//             }
//           } else {
//             itemPriceHtml += this.formatMoney(data.price_min);
//           }
//           itemPriceHtml += '</p>';
//         }

//         itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    
      var itemPriceHtml = '';
      if (data.title != '')  {
        itemPriceHtml += '<p class="grid-link__meta">';
        if (onSale) {
          itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min) + '</s> ';

          if (priceVaries) {
            if(bcSfFilterConfig.label.from_price != undefined){
              itemPriceHtml += '<span class="s-price" style="color: red">' (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min)) +'</span>' ;
            }else {
              itemPriceHtml += '<span class="s-price" style="color: red">' + this.formatMoney(data.price_min)  +'</span>' ;
            }
          }else{
            itemPriceHtml +=  '<span class="s-price" style="color: red">' + this.formatMoney(data.price_min) + '</span>';
          }

        }
        else {
          itemPriceHtml +=  this.formatMoney(data.price_min);
        }
        itemPriceHtml += '</p>';
      }

      itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

      // Add soldOut class
      var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
      itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

      // Add onSale class
      var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
      itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

      // Add soldOut Label
      var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
      itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

      // Add onSale Label
      var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
      itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

      // Add Vendor
      var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
      itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

      // Add main attribute (Always put at the end of this function)
      itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
      itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
      itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
      itemHtml = itemHtml.replace(/{{itemColors}}/g, productcolors);

      return itemHtml;
  };

  // Build Product List Item
  BCSfFilter.prototype.buildProductListItem = function(data) {
      // // Add Description
      // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
      // // Truncate by word
      // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
      // // Truncate by character
      // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
      // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  };

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  BCSfFilter.prototype.buildPagination = function(totalProduct) {
      if (this.getSettingValue('general.paginationType') == 'default') {
          // Get page info
          var currentPage = parseInt(this.queryParams.page);
          var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

          // If it has only one page, clear Pagination
          if (totalPage == 1) {
              jQ(this.selector.bottomPagination).html('');
              return false;
          }

          if (this.getSettingValue('general.paginationType') == 'default') {
              var paginationHtml = bcSfFilterTemplate.paginateHtml;

              // Build Previous
              var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
              previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
              paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

              // Build Next
              var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
              nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
              paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

              // Create page items array
              var beforeCurrentPageArr = [];
              for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                  beforeCurrentPageArr.unshift(iBefore);
              }
              if (currentPage - 4 > 0) {
                  beforeCurrentPageArr.unshift('...');
              }
              if (currentPage - 4 >= 0) {
                  beforeCurrentPageArr.unshift(1);
              }
              beforeCurrentPageArr.push(currentPage);

              var afterCurrentPageArr = [];
              for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                  afterCurrentPageArr.push(iAfter);
              }
              if (currentPage + 3 < totalPage) {
                  afterCurrentPageArr.push('...');
              }
              if (currentPage + 3 <= totalPage) {
                  afterCurrentPageArr.push(totalPage);
              }

              // Build page items
              var pageItemsHtml = '';
              var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
              for (var iPage = 0; iPage < pageArr.length; iPage++) {
                  if (pageArr[iPage] == '...') {
                      pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                  } else {
                      pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                  }
                  pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                  pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
              }
              paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

              jQ(this.selector.bottomPagination).html(paginationHtml);
          }
      }
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  BCSfFilter.prototype.buildFilterSorting = function() {
      if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
          jQ(this.selector.topSorting).html('');

          var sortingArr = this.getSortingList();
          if (sortingArr) {
              // Build content 
              var sortingItemsHtml = '';
              for (var k in sortingArr) {
                  sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
              }
              var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
              jQ(this.selector.topSorting).html(html);

              // Set current value
              jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
          }
      }
  };

  // Build Display type (List / Grid / Collage)
  // BCSfFilter.prototype.buildFilterDisplayType = function() {
  //     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  //     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  //     jQ(this.selector.topDisplayType).html(itemHtml);

  //     // Active current display type
  //     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
  //     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
  //     if (this.queryParams.display == 'list') {
  //         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
  //     } else if (this.queryParams.display == 'grid') {
  //         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
  //     }
  // };

  /************************** END BUILD TOOLBAR **************************/

  // Build Default layout
  function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

  // Customize data to suit the data of Shopify API
  BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

  // Add additional feature for product list, used commonly in customizing product list
  BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

  // Build additional elements
  BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
    var to = from + data.products.length - 1;
      
    if (to > data.total_product) to = data.total_product;
    //   jQ("#esViewingText").html('Showing 1 to ' + to + ' of ' + data.total_product);
    jQ('.collection-count-items').text(data.total_product);
    jQ('.collection-count-items').text(data.total_product);
    
    jQ('.bc-sf-filter-option-block-color > .bc-sf-filter-block-title > h3 > span').addClass('selected1');
    jQ('.bc-sf-filter-option-block-size > .bc-sf-filter-block-title > h3 > span').addClass('selected2');
    jQ('.bc-sf-filter-option-block-price > .bc-sf-filter-block-title > h3 > span').addClass('selected3');

     var windowWidth = $(window).width();

    $('.selected1').click(function(e){
      $('.bc-sf-filter-option-block-color').toggleClass('with-border');
      $('.bc-sf-filter-option-block-size').removeClass('with-border');
      $('.bc-sf-filter-option-block-price').removeClass('with-border');
      $('.bc-sf-filter-option-block-size > .bc-sf-filter-block-content').css("display", "none");
      $('.bc-sf-filter-option-block-price > .bc-sf-filter-block-content').css("display", "none");
      $('.bc-sf-filter-option-block-size > .bc-sf-filter-block-title > h3 > span').addClass('up');
      $('.bc-sf-filter-option-block-price > .bc-sf-filter-block-title > h3 > span').addClass('up');
      
      if(windowWidth < 768){
        $('.bc-sf-filter-option-block-color').toggleClass('bg-white');
        $('.bc-sf-filter-option-block-size').removeClass('bg-white');
        $('.bc-sf-filter-option-block-price').removeClass('bg-white');
      }  
      
    });
    $('.selected2').click(function(e){
      $('.bc-sf-filter-option-block-size').toggleClass('with-border');
      $('.bc-sf-filter-option-block-color').removeClass('with-border');
      $('.bc-sf-filter-option-block-price').removeClass('with-border');
      $('.bc-sf-filter-option-block-color > .bc-sf-filter-block-content').css("display", "none");
      $('.bc-sf-filter-option-block-price > .bc-sf-filter-block-content').css("display", "none");
      $('.bc-sf-filter-option-block-color > .bc-sf-filter-block-title > h3 > span').addClass('up');
      $('.bc-sf-filter-option-block-price > .bc-sf-filter-block-title > h3 > span').addClass('up');
      
      if(windowWidth < 768){
        $('.bc-sf-filter-option-block-size').toggleClass('bg-white');
        $('.bc-sf-filter-option-block-color').removeClass('bg-white');
        $('.bc-sf-filter-option-block-price').removeClass('bg-white');
      }
      
    });

    $('.selected3').click(function(e){
      $('.bc-sf-filter-option-block-price').toggleClass('with-border');
      $('.bc-sf-filter-option-block-color').removeClass('with-border');
      $('.bc-sf-filter-option-block-size').removeClass('with-border');
      $('.bc-sf-filter-option-block-color > .bc-sf-filter-block-content').css("display", "none");
      $('.bc-sf-filter-option-block-size > .bc-sf-filter-block-content').css("display", "none");
      $('.bc-sf-filter-option-block-color > .bc-sf-filter-block-title > h3 > span').addClass('up');
      $('.bc-sf-filter-option-block-size > .bc-sf-filter-block-title > h3 > span').addClass('up');
      
      if(windowWidth < 768){
        $('.bc-sf-filter-option-block-price').toggleClass('bg-white');
        $('.bc-sf-filter-option-block-color').removeClass('bg-white');
        $('.bc-sf-filter-option-block-size').removeClass('bg-white');
      }
      
    });
    
    jQ('.bc-sf-filter-option-item').click(function(e){
      window.location.reload();    
    });
    
    $('#bc-sf-filter-tree-mobile-button').click(function(e){
    	$('#bc-sf-filter-tree-mobile').toggleClass("ft-open");
    });
    
//     ADD TEXT FROM FILTER
    
    jQ('.bc-sf-filter-selection-wrapper > .bc-sf-filter-block-title > h3').append("<p>Selected Filter:</p>")
    jQ('.bc-sf-filter-selection-wrapper > .bc-sf-filter-block-title > a').append("<span>Clear All</span>")
    jQ('#bc-sf-filter-tree-mobile-button').append("<span>FILTER BY</span>")
//     jQ('.bc-sf-filter-option-block-color').before("<div>Filter By</div>")
//     jQ('#bc-sf-filter-options-wrapper > div ').first().addClass( "fby" );

    
    //     REMOVE TEXT FROM FILTER
    jQ('.selected-type').contents().filter(function(){ return this.nodeType == 3; }).remove();
    jQ('.bc-sf-filter-clear-all').contents().filter(function(){ return this.nodeType == 3; }).remove();
    jQ('#bc-sf-filter-tree-mobile-button').contents().filter(function(){ return this.nodeType == 3; }).remove();
    
        
    //     SWATCH FOR COLLECTION

//     var defaultSwatch = jQ('.default-swatch').text().toString();

//     jQ('#bc-sf-filter-products .swatch-option.image').each(function(i,e){
//       var newswatch = defaultSwatch.replace("swatch-red", $(e).data('swatch'));
//       var swatchbg = 'background-image: url("'+newswatch+'")';
//       $(e).attr('style',swatchbg).attr('option-tooltip-thumb',newswatch);
//     });
    
 


    
//     $('#bc-sf-filter-products').on('hover','.swatch-option.image',function(e){
//       var $this = $(this),
//           idx = $this.index(),
//           $parent = $this.closest('.product-item'),
//           $imgContainer = $parent.find('.img-container');
//       $imgContainer.children('img').eq(idx).show().siblings().hide();
//     });


    

// 	COLLECTION BACK TO ORIGINAL IMAGE WHEN MOUSELEAVE
    
      jQ('.collection-content-items').hover(function(){
        var $this = $(this),
            mainFirstImage = $this.find('.collection-img').children('.col-image1').prop('src'),
            mainSecondImage = $this.find('.collection-img').children('.col-image2').prop('src');

        
      }, function(){
		var $this = $(this),
            mainFirtOrigImageData = $this.find('.collection-img').children('.col-image1').attr('data-origsrc'),
            mainSecondOrigImageData = $this.find('.collection-img').children('.col-image2').attr('data-origsrc'),
            mainFirtOrigImageWrap = $this.find('.collection-img').children('.col-image1'),
            mainSecondOrigImageWrap = $this.find('.collection-img').children('.col-image2');
        
        mainFirtOrigImageWrap.attr('src', mainFirtOrigImageData);
        mainSecondOrigImageWrap.attr('src', mainSecondOrigImageData);

         
      });
	
    //     COLLECTION CHANGE IMAGE ON HOVER

    
    jQ('.swatch-option.image').hover(function(){
      var $this = $(this),
          itemFirstImage = $this.data('imgscr1'),
          itemSecondImage = $this.data('imgscr2'),
          newImageWrap1 = $this.closest('.collection-information').closest('.collection-view-item').find('.collection-img').children('.col-image1'),
          newImageWrap2 = $this.closest('.collection-information').closest('.collection-view-item').find('.collection-img').children('.col-image2');
      

      
      newImageWrap1.prop('src',itemFirstImage);
      newImageWrap2.prop('src',itemSecondImage);

    });


    


   
    

  
 
    
    
    
    
    
    
    
//     COLLECTION JSON FOR QUICK VIEW NI SIR RENGIE
    
       // quickview ajax call
    
    function quickAjax(urlJson, $mainDataId, prodPopCOnt) {
      $.ajax({
        type: 'GET',
        url: urlJson,
        success: function(data){
          var $data = JSON.parse(data),
              prdLngth = $data.counts,
              prdData = $data.products,
              imCount = 0,
              imSrc = "",
              imsSrc = "",
              sizeOption = '',
              imSrc2 ="",
              prodSale ="",
              prodVal = '';

         
 

          for (var a = 0; a < prdLngth; a++){
            var currProd = $data.products[a];
            var prdDVar = currProd.variantData;            

            if(currProd.id == $mainDataId){
              var imgln = currProd.images.length,
                  imgSln = currProd.imagesSmall.length,
                  vdln = currProd.variantData.length;
              
              for(test = 0; test < imgln; test++){
                var thisImage = currProd.images[test]
                
                if(test < 1){
                  imSrc = "<div data-imgidx='"+ test +"' class='unique-photo-container' >" +
                    "<img data-src='"+ thisImage +"' class='inner-element' src='"+ thisImage +"'>" +
                  "</div>"
                } 
              }
              

              for( vDCount = 0; vDCount < vdln; vDCount ++ ){
                var vData = currProd.variantData[vDCount],
                    vTitle = vData.title,
                    vId = vData.vid,
                    vSize = vData.size,
                    vColor = vData.imgColor2,
                    vcomPrice = vData.comparePrice,
                    vPrice = vData.mprice,
                	vmcomparePrice = vData.mcomparePrice;
                
             
                
                
    		
                
                if(vcomPrice != "null"){

                  prodSale =  "<div class='product_onsale'>" +
                    "<span class='linethrough sale_price' style='display: inline-block;'>"+ prdDVar[0].mcomparePrice+"</span>" +
                    "<span class='curr_price sale_price' style='display: inline-block;'>"+ prdDVar[0].mprice +"</span>" +
                    "<span class='regular_price' data-bind='css:pricecss, text: price' style='display: none;'>"+  prdDVar[0].mprice +"</span>"+
                    "</div>"
                } else {
                 prodSale = "<div class='product_onsale'>" +
                  "<span class='regular_price' data-bind='css:pricecss, text: price' style='display: block;'>"+  prdDVar[0].mprice +"</span>"+
                  "</div>"
                }
                
                

                

                //function for add to cart to work
                // product price change on variant change


//                 function switchProductPrice(varID){
//                   for (var i = 0; i < vData.length; i++) { 
//                     var currVar = vData[i];
//                     var moneySymbol = "₱";

//                     if(vData.id == varID){
//                       var currPrice = currVar.price/100;
//                       currPrice = currPrice.toFixed(2);
//                       currPrice = vData.price;
                                  
                      
//                       $('.sale_price.linethrough').text(currPrice);
//                       $('.regular_price').text(currPrice);
//                       if(currVar.compare_at_price != null){
//                         var regPrice = currVar.compare_at_price/100;
//                         regPrice = regPrice.toFixed(2);
//                         regPrice = moneySymbol + regPrice.toLocaleString();
//                         $('.regular_price').hide();
//                         $('.sale_price').css({'display':'inline-block'});
//                         $('.sale_price.curr_price').text(currPrice);
//                         $('.sale_price.linethrough').text(regPrice);
      
//                       }else {
//                         $('.sale_price').hide();
//                         $('.regular_price').text(currPrice).show();
//                       }

//                     }
//                   }
//                 }
                
                
                
                imSrc2 = "<img src='"+vColor+"'>";
                
                sizeOption += "<option value='"+ vSize +"' data-id='"+vId+"'>"+ vSize +"</option>";
                if(vDCount < 1 ){
                  prodVal += "<option selected='selected' value='"+vId+"'>"+vTitle+"</option>";
                } else {
                  prodVal += "<option value='"+vId+"'>"+vTitle+"</option>";
                }
              }

              
              
              
              var prodImages =   "<div class='product-single__photos'>" +
                                    "<div class='product-single__photo-wrapper'>" +
                                         imSrc +
                                    "</div>" + 
                                "</div>"
              
             var prodAddCart = "<form method='post' action='/cart/add' id='product_form_3543134535785' accept-charset='UTF-8' class='product-form product-form-superga-product-template product-form--hide-variant-labels' enctype='multipart/form-data'>" +
                          "<input type='hidden' name='form_type' value='product'>" +
                          "<input type='hidden' name='utf8' value='✓'>" +
                          "<div class='product-swatch-option'>" +
                               "<div class='color-container'>" +
                                 "<div class='selection-block'>" +
                                 "<label for='SingleOptionSelector-0'>Color</label>" +
                                   imSrc2 +
                                 "</div>" +
                               "</div>" +

                              "<div class='mtb2'>" +
                                  "<div class='mb0-5 elite-flexbox valign-center flex-justify-center'>" +
                                      "<div class='align-left' style='display: inline-block;'>" +
                                          "<label for='size' class='block valign-middle-children'><span class='inline-block'>SIZE</span></label>" +
                                      "</div>" +
                                      "<div class='flexshrinkgrow0' style='display: none;'><span class='f-color13'>In Stock</span></div>" +
                                  "</div>" +
                                  "<div class='select-container selector-wrapper js product-form__item'>" +
                                      "<select class='option variant single-option-selector single-option-selector-superga-product-template product-form__input' id='SingleOptionSelector-1' data-index='option2'>" +
                                           sizeOption +
                                      "</select>" +
              
                                  "</div>" +
                                  "<div id='err_select_option2'></div>" +
                              "</div>" +
                              "<div class='swatch-size'>" +
                                  "<div class='size-container'>" +
                                      "<select id='Quantity' name='quantity' class='cart-quantity'>" +
                                         "<option value='1'>1</option>" +
                                         "<option value='2'>2</option>" +
                                         "<option value='3'>3</option>" +
                                         "<option value='4'>4</option>" +
                                         "<option value='5'>5</option>" +
                                         "<option value='6'>6</option>" +
                                         "<option value='7'>7</option>" +
                                         "<option value='8'>8</option>" +
                                         "<option value='9'>9</option>" +
                                         "<option value='10'>10</option>" +
                                      "</select>" +
                                      "<input type='hidden' value='2' data-firstqty='2' class='variant-inventory'>" +
                                  "</div>" +
                              "</div>" +
                              "<div class='product-form__item--submit'>" +
                                  "<button type='submit' name='id' id='AddToCart-product-template' class='product-form__cart-submit' data-productid='"+vId+"' value='"+currProd.variantData[0].vid+"'>" +
                                      "<span class='atc-span' id='AddToCartText-product-template'>Add To Bag</span>" +
                                  "</button>" +
                              "</div>" +
                          "</div>" +
                      "</form>"
              
              var prodDetails = "<div class='product_content_wrap'>" + 
                					"<div class='product-content_wrap-main'>" + 
                 						 "<h1 itemprop='name' class='product-single__title'>" + currProd.title + "</h1>" +
                    				"</div>" +
										 prodSale + 
                  					"<div class='prod_shareLink'>" +
                  						"<a href='"+ currProd.collectTitle + "'>"+ 'VIEW DETAILS' +
                                        "</a>" +
                  					"</div>" +
                  						 prodAddCart + 
                   				"</div>"
              
              function appendMiniProd(){
                prodPopCOnt.append(prodImages + prodDetails)

              }
              appendMiniProd(); 
              
              
              // SIZE CHANGE TRIGGER ID SELECT
              
              
               $('#SingleOptionSelector-1').change(function(){
                 var sizeOpts = $(this).find(":selected").data('id');


				 $('#AddToCart-product-template').val(sizeOpts);
     
                 

//                 hiddOpts.removeAttr('selected')

//                 hiddOpts.each(function(){
//                   var hOptsSize = $(this).val()
//                   console.log(hOptsSize)
//                   if(hOptsSize == sizeOpts){

//                     $(this).attr("selected", "selected")
//                   }
//                 })
//                 $("#ProductSelect-product-template").trigger('change');
              });

//               var $productIDselect = $('#ProductSelect-product-template'),
//                   selectedProductID = $productIDselect.val();
//               switchProductPrice(selectedProductID);

//               $productIDselect.change(function(e){
//                 var selectValue = $(this).val();
//                 switchProductPrice(selectValue);
//               });

              
            }
          }
  
        }
        
      })
      
    }

    	
    
    jQ('.quick_view').click(function(e){
      e.preventDefault();
      
      var $this = $(this),
          $container = $this.closest('.collection-content-items'),
          $mainDataId = $container.data('id'),
          url = window.location.href,
          urlJson = url + "?&view=json",
          prodPopCOnt = $('.remodal-wrapper-main'),
          detect = 0;

      $('.remodal-wrapper').addClass("show")

      quickAjax(urlJson, $mainDataId, prodPopCOnt)
      

    });
    
    //     REMOVE POPUP OVERLAY QUICK VIEW
   jQ('.fa-times').click(function(){

     $(".remodal-wrapper").removeClass("show");
     $('.product-single__photos').empty();
     $('.product_content_wrap').empty();
     
    });
   
   
   
    
//     jQ( document ).ready(function() {
//       var url = window.location.href,
//           urlJson = url + "?&view=json",
//           $this = $(this);
      	  
      	
//           quickAjax(urlJson)
//     });


  };


/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
